// components/PillTabs.jsx
import React from "react";


const PillTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="d-flex  mt-1 mb-2">
      <ul className="nav nav-tabs  w-100">
        {tabs.map((tab, index) => (
          <li className="nav-item" key={index}>
            <a
              className={`nav-link ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
             
            >
              {tab}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PillTabs;
